import { BasicTable } from '../components/ReportTables/BasicTable';
import { FundIdentificationCodes } from '../components/ReportTables/FundIdentificationCodes';
import { FundIdentificationCodes2 } from '../components/ReportTables/FundIdentificationCodes2';
import { FundIdentificationCodes3 } from '../components/ReportTables/FundIdentificationCodes3';
import { BaseCurrency } from '../components/ReportTables/BaseCurrency';
import { FundSourceCode } from '../components/ReportTables/FundSourceCode';
import { ShareClasses } from '../components/ReportTables/ShareClasses';
import { InvestmentStrategies } from '../components/ReportTables/InvestmentStrategies';
import { InvestmentStrategies2 } from '../components/ReportTables/InvestmentStrategies2';
import { FundStrategies } from '../components/ReportTables/FundStrategies';
import { PrimeBrokerFund } from '../components/ReportTables/PrimeBrokerFund';
import { MasterAifStatus } from '../components/ReportTables/MasterAifStatus';
import { MasterAIF } from '../components/ReportTables/MasterAIF';
import { MainInstruments } from '../components/ReportTables/MainInstruments';
import { GeographicalFocus } from '../components/ReportTables/GeographicalFocus';
import { PrincipalExposures } from '../components/ReportTables/PrincipalExposures';
import { MostImportPortfolio } from '../components/ReportTables/MostImportantPortfolio';
import { TypicalPositionSize } from '../components/ReportTables/TypicalPositionSize';
import { PrincipalMarkets } from '../components/ReportTables/PrincipalMarkets';
import { InvestorConcetration } from '../components/ReportTables/InvestorConcetration';
import { IndividualExposures } from '../components/ReportTables/IndividualExposures';
import { Turnover } from '../components/ReportTables/Turnover';
import { CurrencyExposures } from '../components/ReportTables/CurrencyExposures';
import { DominantInfluences } from '../components/ReportTables/DominantInfluences';
import { MarketRiskProfile } from '../components/ReportTables/MarketRiskProfile';
import { MeasureRisk } from '../components/ReportTables/MeasureRisk';
import { ValueOfRisk } from '../components/ReportTables/ValueOfRisk';
import { Var } from '../components/ReportTables/Var';
import { Vega } from '../components/ReportTables/Vega';
import { Tranding } from '../components/ReportTables/Tranding';
import { ValueOfCollateral } from '../components/ReportTables/ValueOfCollateral';
import { CountriesCPP } from '../components/ReportTables/CountriesCPP';
import { CountriesMarket } from '../components/ReportTables/CountriesMarket';
import { ExposuresCPP } from '../components/ReportTables/ExposuresCPP';
import { LiquidityProfiles } from '../components/ReportTables/LiquidityProfiles';
import { LiquidityRedemption } from '../components/ReportTables/LiquidityRedemption';
import { LiquidityRedemption2 } from '../components/ReportTables/LiquidityRedemption2';
import { Arragements } from '../components/ReportTables/Arragements';
import { Arragements2 } from '../components/ReportTables/Arragements2';
import { Treatment } from '../components/ReportTables/Treatment';
import { InvestmentGroup } from '../components/ReportTables/InvestmentGroup';
import { FinancingLiquidity } from '../components/ReportTables/FinancingLiquidity';
import { FinancingLiquidity2 } from '../components/ReportTables/FinancingLiquidity2';
import { FinancingLiquidity3 } from '../components/ReportTables/FinancingLiquidity3';
import { Borrowing } from '../components/ReportTables/Borrowing';
import { DerivativesExposure } from '../components/ReportTables/DerivativesExposure';
import { Leverage } from '../components/ReportTables/Leverage';
import { ControlledStucture } from '../components/ReportTables/ControlledStructure';
import { OpenPositions } from '../components/ReportTables/OpenPositions';
import { HistoricalProfile } from '../components/ReportTables/HistoricalProfile';
import { ResultStressTest } from '../components/ReportTables/ResultStressTest';
import { BorrowingSource } from '../components/ReportTables/BorrowingSource';
import { Assumptions } from '../components/ReportTables/Assumptions';
import { HistoricalProfile2 } from '../components/ReportTables/HistoricalProfile2';
import { BasicTableAIF001 } from '../components/ReportTables/BasicTableAIF001';
import { FundIdentificationCodesAIF001 } from '../components/ReportTables/FundIdentificationCodesAIF001';
import { AssumptionsAIF001 } from '../components/ReportTables/AssumptionsAIF001';
import { FundIdentificationCodes3AIF001 } from '../components/ReportTables/FundIdentificationCodes3AIF001';
import { FundIdentificationCodes4AIF001 } from '../components/ReportTables/FundIdentificationCodes4AIF001';
import { MostImportPortfolioAIF001 } from '../components/ReportTables/MostImportantPortfolioAIF001';
import { PrincipalInstruments } from '../components/ReportTables/PrincipalInstruments';
import { BaseCurrencyAIF001 } from '../components/ReportTables/BaseCurrencyAIF001';

export const strategyTableVariants = [
  {
    name: 'Hedge Fund Strategies',
    key: 'HEDGE_STRATEGIES'
  },
  {
    name: 'Private Equity Fund Strategies',
    key: 'PRIVATE_EQUITY_STRATEGIES'
  },
  {
    name: 'Real Estate Fund Strategies',
    key: 'REAL_ESTATE_STRATEGIES'
  },
  {
    name: 'Fund of Funds Strategies',
    key: 'FUND_OF_FUND_STRATEGIES'
  },
  {
    name: 'Other Fund Strategies',
    key: 'OTHER_FUND_STRATEGIES'
  }
];

export const tableSectionsAIF001 = [
  {
    key: 'HEADER_FILE_AIFM',
    title: 'AIFM - Header File',
    sidebarName: '1-3: AIFM - Header File',
    condensed: '1',
    Component: BasicTableAIF001
  },
  {
    key: 'MAIN_INFO',
    title: 'Main Info',
    sidebarName: '4-13: Main Info',
    condensed: '4',
    Component: FundIdentificationCodesAIF001
  },
  {
    key: 'ASSUMPTIONS001',
    title: 'Assumption Description',
    sidebarName: '14-21: Assumption Description',
    condensed: '14',
    Component: AssumptionsAIF001,
    hasAddDelete: true
  },
  {
    key: 'MAIN_INFO_CONTINUATION',
    Component: FundIdentificationCodes3AIF001,
    hasAddDelete: true
  },
  {
    key: 'AIFM_IDENTIFIERS',
    title: 'AIF - Identifiers',
    sidebarName: '22-25: AIF - Identifiers',
    condensed: '22',
    Component: FundIdentificationCodes4AIF001
  },
  {
    key: 'AIFM_FIVE_PRINCIPAL_MARKET',
    title: 'Five principal markets in which it trades on behalf of the AIFs it manages',
    sidebarName:
      '26-29: Five principal markets in which it trades on behalf of the AIFs it manages',
    condensed: '26',
    Component: MostImportPortfolioAIF001
  },
  {
    key: 'AIFM_PRINCIPAL_INSTRUMENT',
    title: 'Five principal instruments in which it trades on behalf of the AIFs it manages',
    sidebarName:
      '30-32: Five principal instruments in which it trades on behalf of the AIFs it manages',
    condensed: '30',
    Component: PrincipalInstruments
  },
  {
    key: 'AIFM_BASE_CURRENCY_DESCRIPTION',
    title:
      'Values of assets under management for all AIFs managed, calculated as set out in Article 2',
    sidebarName: '33-38: Values of assets',
    condensed: '33',
    Component: BaseCurrencyAIF001
  }
];

export const tableSections = [
  {
    key: 'HEADER_FILE',
    title: 'AIF - Header File',
    sidebarName: '1-3: AIF File Header',
    Component: BasicTable,
    sectionTitle: 'AIF - Article 3(3)(d) and Article 24(1) of Directive 2011/61/EU',
    condensed: '1'
  },
  {
    key: 'HEADER_SECTION',
    title: 'AIF - Header Section',
    sidebarName: '4-13: Filing Information',
    Component: FundIdentificationCodes,
    condensed: '4'
  },
  {
    key: 'ASSUMPTIONS',
    title: 'Assumption Description',
    sidebarName: '14-15: Assumptions',
    Component: Assumptions,
    hasAddDelete: true,
    condensed: '14'
  },
  {
    key: 'ASSUMPTIONS2',
    Component: FundIdentificationCodes2,
    sidebarName: '16-23: AIF Info',
    condensed: '16'
  },
  {
    key: 'FUND_ID_CODES',
    title: 'AIF - Identifiers',
    Component: FundIdentificationCodes3,
    sidebarName: '24-32: Identifies',
    condensed: '24'
  },
  {
    key: 'SHARE_CLASSES',
    title: 'Share Class Identification Codes',
    sidebarName: '33-40: Share Classes',
    Component: ShareClasses,
    hasAddDelete: true,
    condensed: '33'
  },
  {
    key: 'MASTER_AIF_STATUS',
    title: 'Master-Feeder Structure',
    Component: MasterAifStatus,
    sidebarName: '41-44: Master-Feeder Structure',
    condensed: '41'
  },
  {
    key: 'MASTER_AIF',
    Component: MasterAIF,
    hasAddDelete: true,
    title: 'Master AIF'
  },
  {
    key: 'PRIME_BROKE_FUNDS',
    title: 'Prime Broker',
    Component: PrimeBrokerFund,
    hasAddDelete: true,
    sidebarName: '45-47: Prime Brokers',
    condensed: '45'
  },
  {
    key: 'BASE_CURRENCY_INFORMATION',
    title: 'Base Currency Information',
    Component: BaseCurrency,
    sidebarName: '48-53: AUM and Base Currency',
    condensed: '48'
  },
  {
    key: 'FUNDING_SOURCE_COUNTRY_CODE',
    title:
      'Jurisdictions of the three main funding sources (excluding units or shares of the AIF bought by investors)',
    Component: FundSourceCode,
    sidebarName: '54-56: Funding Sources',
    condensed: '54'
  },
  {
    key: 'INVESTMENT_STRATEGIES',
    title: 'AIF type',
    Component: InvestmentStrategies2,
    sidebarName: '57: AIF Type',
    condensed: '57'
  },
  ...strategyTableVariants.map((item, index) => ({
    key: item.key,
    title: item.name,
    sidebarName: index === 0 ? '58-61: Strategies' : null,
    Component: function ({ ...restProps }) {
      return <FundStrategies tableKey={item.key} {...restProps} />;
    },
    hasAddDelete: true,
    condensed: index === 0 ? '58' : null
  })),
  {
    key: 'INVESTMENT_STRATEGIES2',
    Component: InvestmentStrategies,
    sidebarName: '62-63: High Frequency Trading',
    condensed: '62'
  },
  {
    key: 'MAIN_INSTRUMENTS',
    title: 'Five main instruments in which the AIF is trading',
    Component: MainInstruments,
    sidebarName: '64-77: Five Main Instruments',
    condensed: '64'
  },
  {
    key: 'GEOGRAPHICAL_FOCUS',
    title: 'Geographical Focus',
    Component: GeographicalFocus,
    sidebarName: '78-93: Geographical Focus',
    condensed: '78'
  },
  {
    key: 'PRINCIPAL_EXPOSURES',
    title:
      'Ten principal exposures of the AIF at the reporting date (most valuable in absolute terms):',
    Component: PrincipalExposures,
    sidebarName: '94-102: Ten Principal Exposures',
    condensed: '94'
  },
  {
    key: 'MOST_IMPORTANT_PORTFOLIO',
    title: 'Most Important Portfolio Concentrations',
    Component: MostImportPortfolio,
    sidebarName: '103-112: Five Portfolio Concentrations',
    condensed: '103'
  },
  {
    key: 'TYPICAL_POSITION_SIZE',
    title: 'Typical deal/position size',
    Component: TypicalPositionSize,
    sidebarName: '113: Typical Deal Size',
    condensed: '113'
  },
  {
    key: 'PRINCIPAL_MARKETS',
    title: 'Three principal markets in which the AIF trades',
    Component: PrincipalMarkets,
    sidebarName: '114-117: Ten Principal Markets',
    condensed: '114'
  },
  {
    key: 'INVESTOR_CONCENTRATION',
    title: 'Investor Concentration',
    Component: InvestorConcetration,
    sidebarName: '118-120: Investor Concentration',
    condensed: '118'
  },
  {
    key: 'INDIVIDUAL_EXPOSURES',
    title:
      'Individual Exposures in which it is trading and the main categories of assets in which the AIF invested as at the reporting date',
    sectionTitle: 'AIF - Article 24(2) of Directive 2011/61/EU',
    Component: IndividualExposures,
    sidebarName: '121-124: Asset Class Exposures',
    condensed: '121'
  },
  {
    key: 'TURNOVER',
    title: 'Value of turnover in each asset class over the reporting months',
    Component: Turnover,
    sidebarName: '125-127: Turnover',
    condensed: '125'
  },
  {
    key: 'CURRENCIES',
    title: 'Currency of Exposures',
    Component: CurrencyExposures,
    hasAddDelete: true,
    sidebarName: '128-130: Currency Exposures',
    condensed: '128'
  },
  {
    key: 'DOMINANT_INFLUENCES',
    title: 'Dominant Influence (see Article 1 of Directive 83/349/EEC)',
    sidebarName: '131-136: Dominant Influence',
    Component: DominantInfluences,
    hasAddDelete: true,
    condensed: '131'
  },
  {
    key: 'MARKET_RISK_PROFILE',
    sidebarName: '137: Expected Annual Return',
    Component: MarketRiskProfile,
    condensed: '137'
  },
  {
    key: 'MARKET_RISK_PROFILE1',
    title: 'Market Risk Profile'
  },
  {
    key: 'MARKET_RISK_MEASURE',
    title: 'Market risk measure',
    Component: MeasureRisk,
    sidebarName: '138-147: Risk Measures',
    condensed: '138'
  },
  {
    key: 'VALUE_FOR_YEARS_RISK_MEASURE',
    title: 'Value of Risk',
    Component: ValueOfRisk
  },
  {
    key: 'VEGA_RISK_MEASURE',
    title: 'Vega',
    Component: Vega
  },
  {
    key: 'VAR_RISK_MEASURE',
    title: 'Var',
    Component: Var
  },
  {
    key: 'TRADING_CLEARING_DETAILS',
    title: 'Trading and clearing mechanisms',
    Component: Tranding,
    sidebarName: '148-156: Trading and Clearing Mechanisms',
    condensed: '148'
  },
  {
    key: 'ALL_COUNTERPARTY_COLLATERAL',
    title:
      'Value of collateral and other credit support that the AIF has posted to all counterparties',
    Component: ValueOfCollateral,
    sidebarName: '157-159: Collateral',
    condensed: '157'
  },
  {
    key: 'TOP_FIVE_COUNTRIES_EXPOSURE_EXCLUDE_CCP',
    title: 'Top Five Counterparty Exposures (excluding CCPs)',
    subTitle:
      'a) Identify the top five counterparties to which the AIF has the greatest mark-to-market net counterparty credit exposure, measured as a percentage of the NAV of the AIF',
    Component: CountriesCPP,
    sidebarName: '160-165: AIF Counterparty Exposures',
    condensed: '160'
  },
  {
    key: 'TOP_FIVE_COUNTRIES_COUNTERPARTY_EXPOSURE',
    title: 'Top Five Counterparty Exposures',
    subTitle:
      'b) Identify the top five counterparties that have the greatest mark-to-market net counterparty credit exposure to the AIF, measured as a percentage of the NAV of the AIF',
    Component: CountriesMarket,
    sidebarName: '166-171: Counterparties Exposed to AIF',
    condensed: '166'
  },
  {
    key: 'CCP_EXPOSURE',
    title: 'Direct clearing through central clearing counterparties (CCPs)',
    Component: ExposuresCPP,
    sidebarName: '172-177: Central Clearing Counterparties',
    condensed: '172'
  },
  {
    key: 'PORTFOLIO_LIQUIDITY_PROFILE',
    title: 'Liquidity Profiles',
    subTitle: 'Portfolio Liquidity Profile',
    sidebarName: '178-185: Portfolio Liquidity',
    Component: LiquidityProfiles,
    condensed: '178'
  },
  {
    key: 'INVESTOR_LIQUIDITY_PROFILE',
    title: 'Investor Liquidity Profile',
    Component: LiquidityRedemption,
    sidebarName: '186-192: Investor Liquidity',
    condensed: '186'
  },
  {
    key: 'INVESTOR_LIQUIDITY_PROFILE2',
    title: 'Investor redemptions',
    Component: LiquidityRedemption2,
    sidebarName: '193-196: Investor Redemption Rights',
    condensed: '193'
  },
  {
    key: 'INVESTOR_ILLIQUID_ASSET_ARRANGEMENT',
    title: 'Special Arrangements and Preferential Treatment',
    Component: Arragements,
    sidebarName: '197-207: Investor Special Arrangements',
    condensed: '197'
  },
  {
    key: 'INVESTOR_ILLIQUID_ASSET_ARRANGEMENT2',
    Component: Arragements2
  },
  {
    key: 'INVESTOR_ILLIQUID_ASSET_ARRANGEMENT3',
    Component: Treatment
  },
  {
    key: 'INVESTOR_GROUP',
    title: 'Breakdown of the ownership of units in the AIF by investor group',
    Component: InvestmentGroup,
    hasAddDelete: true,
    sidebarName: '208-209: Investor Types',
    condensed: '208'
  },
  {
    key: 'FINANCING_PROFILE',
    title: 'Financing liquidity',
    Component: FinancingLiquidity,
    sidebarName: '210-217: Financing Liquidity',
    condensed: '210'
  },
  {
    key: 'FINANCING_PROFILE2',
    Component: FinancingLiquidity2
  },
  {
    key: 'OPEN_POSITIONS',
    title: 'Operational and Other Risk Aspects',
    Component: OpenPositions,
    sidebarName: '218: Number of Open Positions',
    condensed: '218'
  },
  {
    key: 'HISTORICAL_PROFILE',
    title: 'Historical risk profile',
    Component: HistoricalProfile,
    sidebarName: '219-254: Performance and NAV Change',
    condensed: '219'
  },
  {
    key: 'HISTORICAL_PROFILE2',
    title: 'Subscriptions and Redemptions',
    Component: HistoricalProfile2,
    sidebarName: '255-278: Subscriptions and Redemptions',
    condensed: '255'
  },
  {
    key: 'RESULT_OF_STRESS_TESTS',
    title: 'Results of stress tests',
    Component: ResultStressTest,
    sidebarName: '279-280: Stress Tests',
    condensed: '279'
  },
  {
    key: 'COLLATERAL_FLAGS',
    title:
      'Article 24(2) of Directive 2011/61/EU: Information to report when information is not already reported under Article 24(4)',
    sidebarName: '281-282: Rehypothecation',
    sectionTitle: 'AIF - Article 24(4) of Directive 2011/61/EU',
    Component: FinancingLiquidity3,
    condensed: '281'
  },
  {
    key: 'BORROWING_DETAILS',
    title: 'Borrowing and Exposure Risk',
    sidebarName: '283-286: Borrowing Type',
    Component: Borrowing,
    condensed: '283'
  },
  {
    key: 'DERIVATIVE_EXPOSURE',
    title: 'Derivatives Exposure',
    Component: DerivativesExposure,
    sidebarName: '287-289: Derivatives Exposure',
    condensed: '287'
  },
  {
    key: 'CONTROLLED_STRUCTURE',
    title:
      'Gross exposure of financial and, as the case may be, or legal structures controlled by the AIF as defined in Recital 78 of the AIFMD',
    sidebarName: '290-293: Controlled Legal Structures',
    Component: ControlledStucture,
    hasAddDelete: true,
    condensed: '290'
  },
  {
    key: 'LEVERAGE_AIF',
    title: 'Leverage of the AIF expressed as a percentage of the NAV',
    sidebarName: '294-295: Leverage',
    Component: Leverage,
    condensed: '294'
  },
  {
    key: 'BORROWING_SOURCE',
    title: 'Five largest sources of borrowed cash or securities (short positions):',
    sidebarName: '296-301: Top Five Borrowing Sources',
    Component: BorrowingSource,
    condensed: '296'
  }
];

export const sections = tableSections.reduce((acc, item) => {
  if (item.sidebarName) {
    acc[item.key] = item.sidebarName;
  }
  return acc;
}, {});

export const condensedSections = tableSections.reduce((acc, item) => {
  if (item.condensed) {
    acc[item.key] = item.condensed;
  }
  return acc;
}, {});

export const sectionsAIF001 = tableSectionsAIF001.reduce((acc, item) => {
  if (item.sidebarName) {
    acc[item.key] = item.sidebarName;
  }
  return acc;
}, {});

export const sectionsAIF001Condensed = tableSectionsAIF001.reduce((acc, item) => {
  if (item.condensed) {
    acc[item.key] = item.condensed;
  }
  return acc;
}, {});

const multipleTableNamesAIF002 = tableSections
  .filter(item => item.hasAddDelete)
  .reduce((acc, item) => {
    acc[item.key] = item.title;
    return acc;
  }, {});

const multipleTableNamesAIF001 = tableSectionsAIF001
  .filter(item => item.hasAddDelete)
  .reduce((acc, item) => {
    acc[item.key] = item.title;
    return acc;
  }, {});

export const MULTIPLE_TABLE_NAMES = {
  ...multipleTableNamesAIF002,
  ...multipleTableNamesAIF001
};
